import React, { useContext, useEffect, useState } from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";
import { userRoutes, authRoutes } from "./routes/allRoutes";
import { useSelector, useDispatch } from "react-redux";
import Authmiddleware from "./routes/middleware/Authmiddleware";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import "./assets/scss/react.scss";
import { RootState } from "./store/reducers";
import ChangePasswordPage from "./pages/Others/ChangePassword/ChangePasswordPage";
import NotFound from "./pages/Utility/NotFound";
import { SiteSettingsProvider } from "./contexts/AppSettingsContext";
import { RefsProvider, RefsContext } from "./contexts/OnboardingContext";
import useInactivityLogout from "./hooks/useInactivityLogout";
import useSessionExpiry from "./hooks/useSessionExpiry";
import useStorageSync from "./hooks/useStorageSync";
import SpecialAccessLoader from "./components/Authentication/SpecialAccessLoader";
import SessionLockScreen from "./components/Authentication/SessionLockScreen";

// Definido FUERA de App para que React no lo desmonte en cada re-render de App
const SessionHandlers = () => {
  const auth = useSelector((state: RootState) => state.auth);
  useInactivityLogout(auth?.logged ?? false);
  useSessionExpiry(
    auth?.logged ?? false,
    auth?.isLocked ?? false,
    auth?.user?.jwtToken,
  );
  useStorageSync();
  return null;
};

const App = () => {
  const refsContext = useContext(RefsContext);
  
  if (!refsContext) {
    return null; // O maneja el caso donde el contexto no está disponible
  }

  const [visible, setVisible] = useState(true);

  const { layoutType } = useSelector((state: any) => ({
    layoutType: state.Layout.layoutType,
  }));

  const dispatch = useDispatch();
  // const { tooltip1,tooltip2,tooltip3 } = refsContext;

  // useEffect(() => {
  //   if (tooltip1 && tooltip2 && tooltip3) {
  //     // Perform operations that require these refs
  //   }
  // }, [tooltip1, tooltip2, tooltip3]);
  
  // // Example function that uses the refs
  // const scrollToRef = (ref) => {
  //   if (ref && ref.current) {
  //     ref.current.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };
  
  // // Example usage
  // useEffect(() => {
  //   scrollToRef(tooltip1);
  // }, [tooltip1]);
  // // Example usage
  // useEffect(() => {
  //   scrollToRef(tooltip2);
  // }, [tooltip2]);
  // useEffect(() => {
  //   scrollToRef(tooltip3);
  // }, [tooltip3]);

  // const story = [
  //   // {
  //   //   component: 'modal',
  //   //   intro: true,
  //   //   className: 'dshclass',
  //   //   // className: 'mainsidebarcontent',
  //   //   children: (<div>modal content goes here</div>)
  //   // },
  //   {
  //     intro: true,
  //     ref: tooltip2,
  //     component: 'speech-bubble',
  //     children: (<div>Q TA</div>)
  //   },
  //   {
  //     component: 'tooltip',
  //     ref: tooltip1,
  //     children: (<div>HOLA</div>)
  //   },
  //   {
  //     component: 'speech-bubble',

  //     // intro: false,
  //     ref: tooltip3,
  //     children: (<div>HEY</div>)
  //   }
  // ];

  // useEffect(() => {
  //   const refreshToken = getAuthUser().user?.refreshToken;
  //   if (refreshToken)
  //     AuthAPIService.refreshToken(refreshToken)
  //       .then((res) => dispatch(login(res)))
  //       .catch(() => {
  //         dispatch(logout());
  //         removeAuthUser();
  //       });
  // }, []);

  const auth = useSelector((state: RootState) => state.auth);

  function getLayout() {
    let layoutCls: Object = VerticalLayout;
    /*switch (layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }*/
    return layoutCls;
  }

  const ModalCreatePage = () => {
    return (
      <ChangePasswordPage
        tempPass={
          auth?.user?.requiredPasswordChange == null
            ? false
            : auth?.user?.requiredPasswordChange
        }
      />
    );
  };

  const Layout = getLayout();

  return (
    <React.Fragment>
        <SiteSettingsProvider>
          <RefsProvider>
          <Router>
            <SessionHandlers />
            <SpecialAccessLoader />
            <SessionLockScreen />
            <Switch>
              {authRoutes.map((route, idx) => (
                <Authmiddleware
                  path={route.path}
                  layout={NonAuthLayout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={false}
                  exact
                />
              ))}

              {userRoutes.map((route: any, idx: number) => (
                <Authmiddleware
                  path={route.path}
                  layout={Layout}
                  component={route.component}
                  key={idx}
                  isAuthProtected={true}
                  exact
                />
              ))}

              <Route component={NotFound} />
            </Switch>
            {auth?.logged &&
              auth?.user?.requiredPasswordChange &&
              ModalCreatePage()}
          </Router>
          </RefsProvider>
      </SiteSettingsProvider>
    </React.Fragment>
  );
};

export default App;